import {Injectable} from '@angular/core';
import {ApiService} from './api.service';
import {Config} from '../../../config/config';
import {TransferStateService} from './transfer-state.service';

@Injectable({
  providedIn: 'root'
})
export class PressService {

  constructor(private apiService: ApiService, private transferState: TransferStateService) {
  }

  public getArticlesInEvidence() {
    return this.transferState.runApi(
      'press-articles-in-evidence',
      this.apiService.translateApi(lang => this.apiService.get(Config.ENDPOINTS.press.inEvidence(), undefined, undefined, lang))
    );
  }

  public getArticlesInForeground() {
    return this.transferState.runApi(
      'press-articles-in-foreground',
      this.apiService.translateApi(lang => this.apiService.get(Config.ENDPOINTS.press.inForeground(), undefined, undefined, lang))
    );
  }

  public getArticle(slug: string) {
    return this.transferState.runApi(
      `press-articles-${slug}`,
      this.apiService.translateApi(lang => this.apiService.get(Config.ENDPOINTS.press.single(slug), undefined, undefined, lang))
    );
  }

  public getArticles() {
    return this.transferState.runApi(
      `press-articles`,
      this.apiService.translateApi(lang => this.apiService.get(Config.ENDPOINTS.press.all(), undefined, undefined, lang))
    );
  }

  public getArticlesRelated(slug: string) {
    return this.transferState.runApi(
      `press-articles-related-${slug}`,
      this.apiService.translateApi(lang => this.apiService.get(Config.ENDPOINTS.press.related(slug), undefined, undefined, lang))
    );
  }
}
